module.exports = __webpack_public_path__ + "img/hgqc.425cb01d.jpg";